import PaymentSubmittedMain from "@/components/dashboard/paymentSubmitted/PaymentSubmittedMain";

export default function PaymentSubmitted() {
  return <PaymentSubmittedMain />;
}
